<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<ng-container *ngIf="!loading">
  <div class="title-row">
    <h2 class="title">哪一个账号遇到了问题？</h2>
    <div class="order-search">
      <i class="search-icon"></i>
      <input
        type="search"
        placeholder="搜索账号或车次号"
        [(ngModel)]="query"
        (ngModelChange)="filterOrders($event)"
      />
    </div>
  </div>
  <ng-container *ngIf="seats.length > 0; else noData">
    <div class="label">
      我的有效车票 <span class="order-count">{{ seats.length }} 张</span>
    </div>
    <div class="orders">
      <article
        class="order"
        *ngFor="let item of seats"
        [ngClass]="{ 'with-ticket': item.workorders.length > 0 }"
        (click)="select(item)"
      >
        <div class="order-top">
          <div class="product">
            <div class="logo">
              <app-image
                *ngIf="item.product_icon"
                [fileid]="item.product_icon"
                [radius]="8"
              ></app-image>
              <!-- 演示数据没有真实产品图时，用首字母图标兜底 -->
              <span class="demo-logo" *ngIf="!item.product_icon">{{
                (item.order?.platform_name || "?").charAt(0)
              }}</span>
            </div>
            <div class="product-info">
              <div class="pname">{{ item.order.platform_name }}</div>
              <div class="account">{{ item.account }}</div>
            </div>
          </div>
          <span class="pill availability" *ngIf="!(item.workorders.length > 0)">
            <i></i>可用
          </span>
          <span class="pill processing" *ngIf="item.workorders.length > 0">
            <i></i>处理中
          </span>
        </div>
        <div class="order-foot" *ngIf="!(item.workorders.length > 0)">
          <span></span><b>›</b>
        </div>
        <div class="order-foot" *ngIf="item.workorders.length > 0">
          <span>可查看原工单</span><b>›</b>
        </div>
      </article>
    </div>
  </ng-container>
  <ng-template #noData>
    <div class="order-empty">没有找到匹配的订单</div>
  </ng-template>
</ng-container>
